import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { DMSBaseService } from "./dms.base.service";
import { isArray } from "lodash";
import { AssetsSearch, ItemPagination } from "app/modules/admin/apps/file-manager/file-manager.types";
@Injectable({
    providedIn: "root",
})

export class FavouriteService extends DMSBaseService {
    constructor(public provider: ServiceProvider) {
        super("/favourites", provider);
    }

    favorite(selection:string[]|string, favorite: boolean = false) {
        const updatedFav=isArray(selection)?selection:[selection]
        if(favorite){
            return this.save(updatedFav,'')
        }
        else
        {
            return this.deleteWithBody(updatedFav,'');
        }
    }

    getAllFav(paging:ItemPagination){
        const method=`/all?page=${paging.page}&limit=${paging.size}`
        return this.getList(method)
    }
}